<div
  class="flex flex-col gap-2"
  data-testId="workspace-assignments"
>
  @for (workspaceAssignmentOption of workspaceAssignmentsFA.controls; track $index) {
    <div class="flex items-start gap-2 w-full">
      <div class="flex flex-col w-60">
        <p-treeSelect
          [options]="groupedWorkspaces()"
          [ngModel]="workspaceNodesById()[workspaceAssignmentOption.get('workspaceId')?.value]"
          [filter]="true"
          [disabled]="isDisabled()"
          [invalid]="
            enableErrorValidation() && workspaceAssignmentOption.get('workspaceId')?.invalid
          "
          [virtualScroll]="true"
          [virtualScrollOptions]="{
            itemSize: 28,
            scrollHeight: '190px',
            numToleratedItems: 10,
          }"
          (onNodeSelect)="onWorkspaceSelect($event.node.data, $index)"
          class="flx-prime-tree-select w-full"
          placeholder="Select Workspace"
          panelStyleClass="flx-prime-tree-select"
          filterPlaceholder="Search by Workspace"
          appendTo="body"
          data-testId="workspace-tree-select"
        >
          <ng-template
            let-node
            pTemplate="group"
          >
            <span class="cursor-default">
              <flx-workspace-env-type-tag
                [envType]="node.key"
                [name]="node.label"
              />
            </span>
          </ng-template>
          <ng-template
            let-node
            pTemplate="item"
          >
            <ng-container *ngTemplateOutlet="label; context: { $implicit: node }"></ng-container>
          </ng-template>

          <ng-template
            let-node
            let-placeholder="placeholder"
            pTemplate="value"
          >
            @if (node) {
              <ng-container *ngTemplateOutlet="label; context: { $implicit: node }"></ng-container>
            } @else {
              <span class="text-neutral-400">{{ placeholder }}</span>
            }
          </ng-template>
        </p-treeSelect>
        @if (enableErrorValidation() && workspaceAssignmentOption.get('workspaceId')?.invalid) {
          <flx-error>This field is required</flx-error>
        }
      </div>

      <flx-workspace-env-type-tag
        [envType]="
          selectedWorkspacesEnvTypes()[workspaceAssignmentOption.get('workspaceId')?.value]
        "
        [name]="
          selectedWorkspacesEnvTypes()[workspaceAssignmentOption.get('workspaceId')?.value] ||
          'TYPE'
        "
        class="mt-2.5"
        data-testId="workspace-env-badge"
      />
      <flx-select
        [hasClear]="true"
        [hasSearch]="true"
        [multi]="true"
        [allOptions]="userRoleOptions()"
        [options]="filteredUserRoleOptions()"
        [formControl]="workspaceAssignmentOption.get('roleIds')"
        (filterChange)="rolesFilter.set($event)"
        class="flx-ds w-80 ml-auto"
        optionClass="flx-ds"
        optionsDisplayMode="CHIPS_INSIDE"
        placeholder="Select role"
        data-testId="user-role-dropdown"
      >
        @if (enableErrorValidation() && workspaceAssignmentOption.get('roleIds')?.invalid) {
          <flx-error>This field is required</flx-error>
        }
      </flx-select>
      <button
        [disabled]="isDisabled() || workspaceAssignmentsFA.length === 1"
        (click)="removeWorkspaceAssignments($index)"
        class="flx-ds secondary"
        variant="ghost"
        icon="center"
        data-testId="remove-workspace-assignment-button"
        flxButton
      >
        <i
          class="ph ph-trash-simple"
          flxIcon
        ></i>
      </button>
    </div>
  }
</div>

<ng-template
  #label
  let-node
>
  @let tooltipDisabled = label.scrollWidth <= label.offsetWidth;
  <div
    #label
    [pTooltip]="node.label"
    [showDelay]="TOOLTIP_DEFAULT_DELAY"
    [attr.data-testId]="'workspace_' + node.label"
    [tooltipDisabled]="tooltipDisabled"
    class="truncate"
  >
    {{ node.label }}
  </div>
</ng-template>
